<template>
    <div v-if="visible" class="window-container" :style="{ top: y + 'px', left: x + 'px', zIndex: zIndex }" @mousedown="bringToFront">
        <div class="window-header" @mousedown.prevent="startDrag">
            <span class="window-title">État de la connexion</span>
            <div class="window-controls">
                <button @click.stop="toggleMinimize">−</button>
                <button @click.stop="closeWindow">×</button>
            </div>
        </div>

        <div v-show="!minimized" class="window-body">
            <div><strong>Connecté :</strong> {{ getConnexionValeur }}</div>
            <div><strong>Token :</strong> {{ getToken }}</div>
            <div><strong>Application lancée :</strong> {{ getAppliLance }}</div>
            <div><strong>Appli lancée valide ?</strong> {{ getAppliLaunched }}</div>
            <div><strong>URL du backend :</strong> {{ getBackEndLink }}</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                minimized: false,
                visible: true,
                dragging: false,
                x: 100,
                y: 100,
                offsetX: 0,
                offsetY: 0,
                zIndex: 1000
            };
        },
        computed: {
            ...mapGetters('ConnexionStore', [
                'getConnexionValeur',
                'getToken',
                'getAppliLance',
                'getAppliLaunched',
                'getLesApplis',
                'getBackEndLink'
            ])
        },
        methods: {
            toggleMinimize() {
                this.minimized = !this.minimized;
            },
            closeWindow() {
                this.visible = false;
            },
            startDrag(e) {
                this.dragging = true;
                this.offsetX = e.clientX - this.x;
                this.offsetY = e.clientY - this.y;
                document.addEventListener('mousemove', this.onDrag);
                document.addEventListener('mouseup', this.stopDrag);
            },
            onDrag(e) {
                if (this.dragging) {
                    this.x = e.clientX - this.offsetX;
                    this.y = e.clientY - this.offsetY;
                }
            },
            stopDrag() {
                this.dragging = false;
                document.removeEventListener('mousemove', this.onDrag);
                document.removeEventListener('mouseup', this.stopDrag);
            },
            bringToFront() {
                this.zIndex += 1;
            }
        }
    };
</script>

<style scoped>
    .window-container {
        position: absolute;
        width: 300px;
        background-color: #f4f4f4;
        border: 1px solid #ccc;
        border-radius: 4px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        font-family: Arial, sans-serif;
        user-select: none;
    }

    .window-header {
        background-color: #007acc;
        color: white;
        padding: 8px 10px;
        cursor: move;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .window-title {
        font-weight: bold;
        margin-right: auto;
    }

    .window-controls {
        display: flex;
        gap: 5px;
    }

        .window-controls button {
            background: none;
            border: none;
            color: white;
            font-size: 16px;
            cursor: pointer;
            padding: 0 6px;
            line-height: 1;
        }

            .window-controls button:hover {
                color: #ffdddd;
            }

    .window-body {
        padding: 10px;
        font-size: 14px;
    }
</style>
